export default __webpack_public_path__ + "static/media/browse.70550f37.png";